import React from 'react';
export function HeroSection() {
  return <section id="hero-section" className="relative w-full flex flex-col text-center px-4 pt-8 pb-10 sm:pt-12 sm:pb-16 items-center justify-center overflow-hidden bg-bg-main" data-id="element-115">
      {/* Brand */}
      <span className="relative inline-block font-serif font-black text-lg sm:text-2xl tracking-tight text-primary mb-3 sm:mb-4" data-id="element-116">
        Profe<span className="text-text-main" data-id="element-117">Pack</span>
      </span>

      {/* Main headline */}
      <h1 className="relative font-serif font-black max-w-4xl text-[30px] leading-[1.12] sm:text-5xl md:text-6xl sm:leading-[1.1] mb-3 sm:mb-5 tracking-tight text-text-main" data-id="element-118">
        Resuelve un año entero de clases de Matemática en solo{' '}
        <span className="text-primary italic font-serif" data-id="element-119">5 minutos</span>
      </h1>

      {/* Subheadline */}
      <p className="relative text-sm sm:text-lg font-medium leading-relaxed mb-5 sm:mb-7 max-w-2xl mx-auto text-text-sec" data-id="element-120">
        Más de 2.000 profesores ya dejaron de improvisar. Entra al aula con todo
        listo para explicar, motivar y lograr que tus alumnos realmente
        aprendan.
      </p>

      {/* Mockup image */}
      <div className="relative w-full max-w-[260px] sm:max-w-[400px] md:max-w-[480px] mx-auto mb-6 sm:mb-8" data-id="element-121">
        <img src="https://cdn.magicpatterns.com/uploads/fbqDJ9yWyjjcpT2MeXdMS8/8e64130a-c353-46be-9cf0-0d9b1f542d60-Photoroom.webp" alt="MATEMÁTICA LISTA — Pack digital con 12 tomos para docentes de Primaria y Secundaria" className="relative w-full h-auto object-contain sm:drop-shadow-[0_20px_40px_rgba(232,69,69,0.12)]" width={620} height={620} fetchPriority="high" loading="eager" decoding="async" data-id="element-122" />
      </div>

      {/* CTA Button */}
      <a href="#pricing" className="relative btn-primary-pulse font-bold text-base sm:text-xl px-8 sm:px-12 py-4 sm:py-5 rounded-full transition-colors inline-block mb-3 sm:mb-4 w-full sm:w-auto max-w-xl text-white bg-primary hover:bg-primary-hover shadow-[0_10px_30px_-10px_rgba(232,69,69,0.5)]" data-id="element-123">
        QUIERO EL PACK MATEMÁTICA LISTA
      </a>

      {/* Trust badges */}
      <p className="text-text-sec text-xs sm:text-sm font-medium flex items-center justify-center gap-2 flex-wrap" data-id="element-124">
        <span data-id="element-125">Descarga inmediata</span>
        <span data-id="element-126">·</span>
        <span data-id="element-127">Sin suscripción</span>
        <span data-id="element-128">·</span>
        <span data-id="element-129">Acceso de por vida</span>
        <span data-id="element-130">·</span>
        <span data-id="element-131">Garantía 7 días</span>
      </p>
    </section>;
}